













import { computed } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { getPageUrl } from '@/router'
import { Track } from '@/utils'
import { UserUtils } from '@/views/user/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-售后',
        }))
      }

      // 加载状态
      loading = computed(() => this.userData.loading)

      userData = useApi(() => UserUtils.getInfo())

      query = useQuery<{
        orderNo: string
      }>()

      url = computed(() =>
        getPageUrl(
          'OrderDetail',
          {
            orderNo: this.query.orderNo,
          },
          {
            env:
              process.env.VUE_APP_RUN_ENV === 'production' ? 'prod' : 'test',
            user: this.userData.data.userName,
          },
        ),
      )
    },
)
